export const SETTINGS_TABS = [
	{ id: "account", labelKey: "betto.profile.accountInfo", testId: "button-settings-account" },
	{
		id: "security",
		labelKey: "betto.profile.security",
		testId: "button-settings-security",
		hasWarning: true,
	},
	{
		id: "preferences",
		labelKey: "betto.profile.preferences",
		testId: "button-settings-preferences",
	},
];

export const DEFAULT_SETTINGS_TAB = "account";

export const PROFILE_NAV_ITEMS = [
	{
		key: "settings",
		labelKey: "betto.profile.globalSettings",
		link: "/profile/settings",
		testId: "button-profile-nav-settings",
	},
	{
		key: "inbox",
		label: "Notifications",
		link: "/profile/inbox",
		testId: "button-profile-nav-inbox",
	},
	{
		key: "history",
		label: "History",
		link: "/profile/history",
		testId: "button-profile-nav-history",
	},
	{
		key: "documents",
		label: "Documents",
		link: "/profile/documents",
		testId: "button-profile-nav-documents",
	},
	{
		key: "bonuses",
		label: "My Bonuses",
		link: "/profile/bonuses",
		testId: "button-profile-nav-bonuses",
	},
	{
		key: "cashback",
		label: "Cashback",
		link: "/profile/cashback",
		testId: "button-profile-nav-cashback",
	},
	{
		key: "promoCode",
		label: "Promo Code",
		link: "/profile/promo-code",
		testId: "button-profile-nav-promo-code",
	},
];

export const WALLET_NAV_ITEMS = [
	{
		key: "deposit",
		labelKey: "betto.profile.deposit",
		link: "/profile/deposit",
		testId: "button-profile-nav-deposit",
	},
	{
		key: "withdraw",
		labelKey: "betto.profile.withdraw",
		link: "/profile/withdraw",
		testId: "button-profile-nav-withdraw",
	},
];
